import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Plx from 'react-plx';
import { StaticImage } from "gatsby-plugin-image"
import colors from '../../../../helpers/colors';

const Wrapper = styled.div`
    overflow: hidden;
    width: 100%;
    
    .h-box {
        width: 450px;
        height:300px;
    }
    
    .h-box {
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${colors.mvWhite};
    }
    
    .one {
        width: 278px;
    }
    .two {
        width: 278px;
    }
    .three {
        width: 370px;
    }
    .four {
        width: 278px;
    }
    .five {
        width: 470px;
    }
    .six {
        width: 278px;
    }
    .seven {
        width: 278px;
    }
    .eight {
        width: 370px;
    }
    .nine {
        width: 378px;
    }
    .ten {
        width: 278px;
    }
    
    #scrollHorizontal {
        display:flex;
        flex-direction: row;
        width: 2500px;
        align-items: center;
    }
  }
`;


const Scroll = () => {
    const [windowSize, setWindowSize] = useState(null);
    const [start, setStart] = useState(null)
    const [end, setEnd] = useState(null)
    const [endValue, setEndValue] = useState(null)

    useEffect(() => {
        if (typeof window !== 'undefined' && window.innerWidth) {
            setWindowSize(window.innerWidth)
        } 

        const handleResize = () => {
            setWindowSize(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        if (windowSize > 1500) {
            setStart(500);
            setEnd(2000)
            setEndValue(-1100);
        } else if (windowSize < 1050 && windowSize > 769) {
            setStart(400);
            setEnd(1100);
            setEndValue(-1400);
        } else if (windowSize < 769 && windowSize > 500) {
            setStart(1050);
            setEnd(2000);
            setEndValue(-1700);
        } else if (windowSize < 500) {
            setStart(1250);
            setEnd(2000);
            setEndValue(-1700);
        }
        return () => window.removeEventListener('resize', handleResize)
    }, [windowSize])

    const parallaxData = [
        {
          start: start,
          end: end,
          properties: [
            {
              startValue: 0,
              endValue: endValue,
              property: 'translateX',
            },
          ],
        },
    ];

    return (   
        <Wrapper>     
             <Plx
                className='MyAwesomeParallax'
                parallaxData={ parallaxData }
            >                
                <div id="scrollHorizontal">
                    <div className="one">
                        <StaticImage src="../../../../resources/images/careers/slider-1.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div>
                    <div className="two">
                        <StaticImage src="../../../../resources/images/careers/slider-2.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div>
                    <div className="three">
                        <StaticImage src="../../../../resources/images/careers/slider-3.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div>
                    <div className="four">
                        <StaticImage src="../../../../resources/images/careers/slider-4.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div>
                    <div className="five">
                        <StaticImage src="../../../../resources/images/careers/slider-5.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div>
                    <div className="six">
                        <StaticImage src="../../../../resources/images/careers/slider-6.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div> 
                    <div className="seven">
                        <StaticImage src="../../../../resources/images/careers/slider-7.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div> 
                    <div className="eight">
                        <StaticImage src="../../../../resources/images/careers/slider-8.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div> 
                    <div className="nine">
                        <StaticImage src="../../../../resources/images/careers/slider-9.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div> 
                    <div className="ten">
                        <StaticImage src="../../../../resources/images/careers/slider-10.png" alt="Image in a horizontal image scroll of some team members at Motivosity" quality="100" />
                    </div> 
                </div>

            </Plx> 
           
        </Wrapper> 
    );
};

export default Scroll;
